(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bh-hero-showcase"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function initShowcase(root){
      if (!root || root.dataset.bhHeroInit === 'true') return;
      root.dataset.bhHeroInit = 'true';

      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-bh-hero-slide]'));
      var dots   = Array.prototype.slice.call(root.querySelectorAll('[data-bh-hero-dot]'));
      if (slides.length <= 1) return;

      var interval = parseInt(root.getAttribute('data-interval'), 10);
      if (!interval || interval < 1500) interval = 6000;

      var current = 0;
      var timer = null;
      var reducedMediaQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

      function isReduced(){
        return !!(reducedMediaQuery && reducedMediaQuery.matches);
      }

      function goTo(index){
        current = ((index % slides.length) + slides.length) % slides.length;
        slides.forEach(function(s, i){
          var active = (i === current);
          s.classList.toggle('is-active', active);
          s.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        dots.forEach(function(d, i){
          var active = (i === current);
          d.classList.toggle('is-active', active);
          d.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      }

      function start(){
        stop();
        if (isReduced()) return;
        timer = window.setInterval(function(){ goTo(current + 1); }, interval);
      }
      function stop(){
        if (timer){ window.clearInterval(timer); timer = null; }
      }

      dots.forEach(function(dot, i){
        dot.addEventListener('click', function(){
          goTo(i);
          start();
        });
      });

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);

      if (reducedMediaQuery){
        var onChange = function(){ if (isReduced()) stop(); else start(); };
        if (reducedMediaQuery.addEventListener) reducedMediaQuery.addEventListener('change', onChange);
        else if (reducedMediaQuery.addListener) reducedMediaQuery.addListener(onChange);
      }

      document.addEventListener('visibilitychange', function(){
        if (document.hidden) stop(); else start();
      });

      start();
    }

    function bootAll(scope){
      (scope || document).querySelectorAll('[data-bh-hero-showcase]').forEach(initShowcase);
    }

    if (document.readyState === 'loading'){
      document.addEventListener('DOMContentLoaded', function(){ bootAll(document); });
    } else {
      bootAll(document);
    }

    document.addEventListener('shopify:section:load', function(e){
      bootAll(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
